import { Injectable } from '@angular/core';
import { Acumatica, AcumaticaFieldFormat } from '../acumatica-field-decorator';
import { AcumaticaRequestOptions, AcumaticaService } from '../acumatica.service';
import { AcumaticaEntity, AcumaticaEntityService } from './acumatica-entity';
import { PurchaseOrderService, PurchaseOrder } from './PurchaseOrder.service';
import { StockItem, StockItemService } from './StockItem.service';
import { Observable } from 'rxjs';
import { AcumaticaLoadingOptions } from '../loading-indicator/AcumaticaLoadingOptions';

@Injectable({
    providedIn: 'root'
})
export class PurchaseReceiptService extends AcumaticaEntityService {
    constructor(
        acumatica: AcumaticaService,
        private purchaseOrders: PurchaseOrderService,
    ) {
        super(acumatica, 'PurchaseReceipt', PurchaseReceipt);
    }

    get(ReceiptType: string, ReceiptNbr: string, options: AcumaticaRequestOptions = {}): Observable<PurchaseReceipt> {
        return super.getEntity([ReceiptType, ReceiptNbr], {
            ...{ loader: "Getting Purchase Receipt" },
            ...options
        })
    }

    put(POReceipt: PurchaseReceipt, options: AcumaticaRequestOptions = {}): Observable<PurchaseReceipt> {
        return new Observable<PurchaseReceipt>(subscriber => {
            super.putEntity(POReceipt, options).subscribe(
                POReceipt => {
                    subscriber.next(POReceipt)
                },
                error => {
                    subscriber.error(error);
                });
        });
    }

    // createReceipt(POOrderType: string, POOrderNbr: string, options: AcumaticaRequestOptions = {}): Observable<PurchaseReceipt> {
    //     return new Observable<PurchaseReceipt>(subscriber => {
    //         let errorHandler = (error: AcumaticaError) => {
    //             if (error instanceof NotFoundError) error.message = "Invalid Purchase Order Number";
    //             subscriber.error(error);
    //         };

    //         // get the purchase order
    //         let getPOOpts = {
    //             expand: ['Details'],
    //             loader: 'Getting Purchase Order'
    //         };
    //         this.purchaseOrders.get(POOrderType, POOrderNbr, getPOOpts)
    //             .subscribe((po: PurchaseOrder) => {
    //                 if (po.Status != 'Open') {
    //                     subscriber.error(new Error('Can not create Receipt\nPurchase Order Status is ' + po.Status));
    //                     return;
    //                 }

    //                 // add the Purchase Order lines to the Purchase Receipt
    //                 let receipt = new PurchaseReceipt();
    //                 receipt.VendorID = po.VendorID;
    //                 po.Details?.filter(poline => poline.OrderQty > poline.QtyOnReceipts)
    //                     .forEach(poline => {
    //                         let prline = new PurchaseReceiptDetail();
    //                         prline.POOrderType = po.Type;
    //                         prline.POOrderNbr = po.OrderNbr;
    //                         prline.POLineNbr = poline.LineNbr;
    //                         prline.InventoryID = poline.InventoryID;
    //                         // prline.ReceiptQty = poline.OrderQty - poline.QtyOnReceipts;
    //                         prline.Location = 'DOCK00';
    //                         receipt.Details.push(prline);
    //                     });

    //                 // save the new Receipt to Acumatica
    //                 this.put(receipt, {
    //                     loader: 'Creating Purchase Receipt'
    //                 }).subscribe(newReceipt => {
    //                     subscriber.next(receipt);
    //                 })

    //             }, errorHandler)
    //     });
    // }

    /* this Release function was intended to be used for standard goods Purchase Receipt
        it became problematic with Sales Rep inventory initialization */

    // Release(POReceipt: PurchaseReceipt): Observable<PurchaseReceipt> {
    //     return new Observable<PurchaseReceipt>(subscriber => {
    //         this.put(POReceipt).subscribe((modifiedReceipt: PurchaseReceipt) => {
    //             // updating PO Receipt response includes Details, but not Allocations
    //             // Details are not necessary to be sent for Release
    //             delete modifiedReceipt.Details;

    //             this.acumatica.action(
    //                 'PurchaseReceipt',
    //                 'ReleasePurchaseReceipt',
    //                 modifiedReceipt,
    //                 null,
    //                 { message: 'Releasing Purchase Receipt' }
    //             ).subscribe(subscriber);
    //         });
    //     })
    // }

    Release2(receipt: PurchaseReceipt, options?: AcumaticaLoadingOptions): Observable<PurchaseReceipt> {
        return new Observable<PurchaseReceipt>(subscriber => {
            options = { ...{ message: "Releasing Purchase Receipt" }, ...options };

            // do not further modify the details of the receipt in Acumatica            
            // (issue with how Allocation quantity is totaled for line detail quantity)
            delete receipt.Details;

            this.acumatica.action(
                'PurchaseReceipt',
                'ReleasePurchaseReceipt',
                receipt,
                null,
                options
            ).subscribe(subscriber);
        })
    }

    ReceiveWhseTransferShipment(POReceipt: PurchaseReceipt, ShipmentNbr: string, loader_options?: AcumaticaLoadingOptions): Observable<PurchaseReceipt> {
        return new Observable<PurchaseReceipt>(subscriber => {
            let parms = {
                APIInvoked: true,
                ShipmentNbr: ShipmentNbr
            };

            this.acumatica.action('PurchaseReceipt', 'ReceiveWhseTransferShipment', POReceipt, parms, loader_options).subscribe(() => {
                this.get(POReceipt.Type, POReceipt.ReceiptNbr, {
                    expand: 'Details'
                }).subscribe(updatedReceipt => {
                    subscriber.next(updatedReceipt);
                    subscriber.complete();
                });
            });
        });
    }
}

export class PurchaseReceiptDetailAllocation extends AcumaticaEntity {
    @Acumatica() LineNbr!: number;
    @Acumatica() Location: string | null = null;
    @Acumatica() LotSerialNbr: string | null = null;
    @Acumatica({
        // when writing Qty to Acumatica, write 0 when not Received
        writer: (value: any, entity: AcumaticaEntity): any =>
            (<PurchaseReceiptDetailAllocation>entity).received ? value : 0
    }) Qty!: number;
    @Acumatica() SplitLineNbr!: number;

    received?: boolean = undefined;

    constructor(init?: Partial<PurchaseReceiptDetailAllocation>) {
        super();

        if (init !== undefined) Object.assign(this, init);
    }
}

export class PurchaseReceiptDetail extends AcumaticaEntity {
    private acumatica?: AcumaticaService;

    constructor();
    constructor(acumatica: AcumaticaService);
    constructor(init: Partial<PurchaseReceiptDetail>);
    constructor(private arg1?: AcumaticaService | Partial<PurchaseReceiptDetail>) {
        super(arg1);
    }

    private _InventoryID!: string;
    @Acumatica()
    get InventoryID() { return this._InventoryID; }
    set InventoryID(value) {
        this._InventoryID = value;

        // Get Item data
        let stockItems = this.acumatica?.injector.get(StockItemService);
        if (stockItems) stockItems.get(value!, { loader: null }, false)
            .subscribe(item => this.item = item);
    }
    item!: StockItem;

    @Acumatica() LineNbr!: number;
    @Acumatica('Warehouse') WarehouseID!: string;
    @Acumatica('OrderedQty') OrderQty!: number;
    @Acumatica() OpenQty!: number;

    @Acumatica({
        // // do not read the value from Acumatica -- field is read-only internally
        // read: false,
        // when writing to Acumatica, sum Received allocations, delete Unreceived
        writer: (value: any, entity: AcumaticaEntity) => {
            let detail = <PurchaseReceiptDetail>entity;
            let receiptQty = 0;
            detail.Allocations.forEach(alloc => {
                if (alloc.received)
                    receiptQty += alloc.Qty;
                else
                    (<any>alloc).__delete = true;
            })
            if (receiptQty == 0) (<any>detail).__delete = true;
            return receiptQty;
        }
    })
    get ReceiptQty(): number {
        let receiptQty = 0;
        this.Allocations.forEach(alloc => receiptQty += alloc.Qty);
        return receiptQty;
    }
    set ReceiptQty(value: number) {
        this.Allocations = [
            new PurchaseReceiptDetailAllocation({ Qty: value })
        ]
    }
    @Acumatica() LineType!: string;
    @Acumatica() Location: string | null = null;
    @Acumatica() LotSerialNbr!: string;
    @Acumatica() POOrderType!: string;
    @Acumatica() POOrderNbr!: string;
    @Acumatica() POLineNbr!: number;
    @Acumatica() UOM!: string;
    @Acumatica() Warehouse!: string;
    @Acumatica() AlternateID?: string;
    @Acumatica('TransactionDescription') Description: string | null = null;

    @Acumatica(PurchaseReceiptDetailAllocation)
    Allocations: PurchaseReceiptDetailAllocation[] = [];

    allPiecesReceived() {
        let received = true;
        this.Allocations.forEach(alloc => received = received && (alloc.received ?? false));
        return received;
    }
}

export class PurchaseReceipt extends AcumaticaEntity {
    @Acumatica() note!: string;
    @Acumatica() Type: string = 'Receipt';
    @Acumatica() ReceiptNbr!: string;
    @Acumatica() VendorID!: string;
    @Acumatica() Status!: string;
    @Acumatica({ format: AcumaticaFieldFormat.Date }) Date!: Date;
    @Acumatica() Warehouse: string | null = null;

    @Acumatica(PurchaseReceiptDetail) Details?: PurchaseReceiptDetail[];

    constructor(init?: Partial<PurchaseReceipt>) {
        super();

        if (init !== undefined) Object.assign(this, init);
    }

    allLinesReceived() {
        let received = true;
        this.Details?.forEach(detail => received = received && (detail.allPiecesReceived() ?? false));
        return received;
    }
}